<template>
    <v-sheet v-if="menuItems?.length" tag="nav" position="absolute" width="100%" color="transparent" style="top: 0">
        <v-slide-y-transition>
            <div v-show="childMenuItems?.length">
                <v-sheet color="secondary" height="62" class="d-flex align-center">
                    <v-container fluid class="py-0 px-md-10">
                        <div style="padding-left: 150px">
                            <v-row dense class="px-4">
                                <v-col v-for="item in childMenuItems" :key="item.id" cols="auto" class="px-6">
                                    <v-btn
                                        variant="text"
                                        class="px-2 rounded-0 text-h6"
                                        :href="item.link"
                                        :target="item.isExternalLink ? '_blank' : undefined"
                                    >
                                        {{ item.displayName }}
                                        <template v-slot:append v-if="item.isExternalLink">
                                            <v-icon icon="mdi-open-in-new" size="20px"></v-icon>
                                        </template>
                                    </v-btn>
                                </v-col>
                            </v-row>
                        </div>
                    </v-container>
                </v-sheet>
            </div>
        </v-slide-y-transition>
    </v-sheet>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { VSheet, VSlideYTransition, VContainer, VRow, VCol } from 'vuetify/components';
import { MenuPageLink } from '../../composables/MenuProvider';

interface Props {
    menuItems?: MenuPageLink[];
    selectedMenuItem?: number;
}

const props = defineProps<Props>();

const childMenuItems = computed(() => props.menuItems?.find(x => x.id === props.selectedMenuItem)?.childPages);
</script>
